import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';

export const AuthManager = {
  confirmEmail: ({ data } = DEFAULT_PARAMS) => rHandler(
    apiService.post(`confirm-email`, data),
    (response) => ({ response }),
    (error) => ({ error }),
  ),
  confirmEmailVerify: ({ data } = DEFAULT_PARAMS) => rHandler(
    apiService.post(`confirm-email/confirm`, data),
    (response) => ({ response }),
    (error) => ({ error }),
  ),
};
